<template>
  <v-card flat tile>
    <v-container>
      <v-layout row wrap ml-2>
        <v-flex xs11 sm5 md3 mx-2>
          <v-menu
            v-model="dateMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="formData.date"
                label="Date"
                prepend-icon="mdi-calendar"
                readonly
                v-on="on"
                :disabled="savingForm == true"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="formData.date"
              @input="dateMenu = false"
            ></v-date-picker>
            <!-- <v-date-picker
              v-model="formData.date"
              @input="dateMenu = false"
              :min="currentWeek[0]"
              :max="currentDate"
            ></v-date-picker> -->
          </v-menu>
        </v-flex>
        <v-flex xs11 sm5 md3 mx-2>
          <v-text-field
            label="Cost"
            prepend-icon="mdi-currency-usd"
            v-model="cost"
            @keypress="isNumber"
            :disabled="savingForm == true"
          ></v-text-field>
        </v-flex>
        <v-flex xs11 sm5 md3 mx-2 v-if="taskRate > 0 && userAdmin == true">
          <v-text-field
            label="Markup %"
            v-model="markupPercent"
            @keypress="isNumber"
            disabled
          ></v-text-field>
        </v-flex>
        <v-flex xs11 sm5 md3 mx-2 v-if="taskRate > 0 && userAdmin == true">
          <v-text-field
            label="Billed Amount"
            v-model="billedAmount"
            prepend-icon="mdi-cash-usd-outline"
            @keypress="isNumber"
            :disabled="savingForm == true"
          ></v-text-field>
        </v-flex>
        <v-flex xs11 sm5 md3 mx-2>
          <v-switch
            label="Reimburse"
            colo="primary"
            v-model="formData.reimburse"
            :disabled="savingForm == true"
          ></v-switch>
        </v-flex>

        <v-flex xs11 sm5 md3 mx-2>
          <v-file-input
            label="Attach Receipt"
            v-model="fileData"
            :disabled="savingForm == true || formData.s3FilePath != null"
          ></v-file-input>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex mr-2>
          <v-textarea
            filled
            label="Expense Description"
            auto-grow
            v-model="formData.description"
            :disabled="
              savingForm == true || formData.cost == 0 || formData.cost == null
            "
          ></v-textarea>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
</template>
<script>
import moment from 'moment'

export default {
  name: 'SubmitExpenseForm',
  props: ['userid', 'data', 'savingForm', 'action'],
  data: () => ({
    formTitle: 'Add New Expense Submission',
    dateMenu: false,
    presignedUrl: null,
    projectMenuDisabled: false,
    fileData: null,
    s3FilePath: null,
    s3FileContentType: null,
    taskRate: null,
    cost: 0,
    billedAmount: 0,
    markupPercent: null,
    formData: {
      userId: null,
      date: null,
      description: null,
      reimburse: false,
    },
  }),
  computed: {
    projectStoreData() {
      return this.$store.getters.getProjects
    },
    loggedInUser() {
      return this.$store.getters.getLoggedInUser
    },
    submitUserId() {
      return this.userid != null ? this.userid : this.loggedInUser.id
    },
    currentWeek() {
      return this.$store.getters.getCurrentWeek
    },
    currentDate() {
      return new moment().format('YYYY-MM-DD')
    },
    userAdmin() {
      if (
        this.loggedInUser.type == 'Admin' ||
        this.loggedInUser.type == 'Manager'
      ) {
        return true
      } else {
        return false
      }
    },
    validForm() {
      return (
        this.formData.date !== null &&
        this.formData.date !== '' &&
        this.formData.cost !== null &&
        this.formData.cost > 0 &&
        this.formData.billedAmount !== null &&
        this.formData.billedAmount !== '' &&
        this.formData.description !== null &&
        this.formData.description !== '' &&
        this.formData.description !== undefined &&
        (this.action != 'Edit' ||
          this.formData.date != this.data.date ||
          parseFloat(this.formData.cost) - parseFloat(this.data.cost) != 0 ||
          parseFloat(this.formData.billedAmount) -
            parseFloat(this.data.billedAmount) !=
            0 ||
          this.formData.reimburse != this.data.reimburse ||
          this.formData.description != this.data.description ||
          this.fileData != null)
      )
    },
  },
  watch: {
    savingForm(newVal, oldVal) {
      if (newVal == true && oldVal == false) {
        this.$emit(
          'loading',
          this.action == 'Delete'
            ? 'Deleting Expense Submission'
            : this.action + 'ing Expense Submission'
        )
        this.getPresignedUrl()
      }
    },
    validForm(val) {
      if (val == true) {
        this.$emit('valid-form', true)
      } else {
        this.$emit('valid-form', false)
      }
    },
    cost(val) {
      this.formData.cost = val
      if (this.taskRate > 0 && val != null && val != '') {
        this.billedAmount = (
          parseFloat(val) +
          (parseFloat(val) * parseFloat(this.markupPercent)) / 100
        ).toFixed(2)
      }
    },
    billedAmount(newVal, oldVal) {
      if (
        newVal != oldVal &&
        newVal != null &&
        newVal != '' &&
        this.cost != null &&
        this.cost != ''
      ) {
        this.formData.billedAmount = parseFloat(newVal)
        this.markupPercent = (
          (parseFloat(newVal) / parseFloat(this.cost) - 1) *
          100
        ).toFixed(2)
      }
    },
  },
  methods: {
    submitExpense() {
      if (this.action == 'Add') {
        this.addExpenseSubmission()
      } else if (this.action == 'Edit') {
        this.editExpenseSubmission()
      } else if (this.action == 'Delete') {
        this.deleteExpenseSubmission()
      }
    },
    prepareFormDataForSubmit() {
      this.formData.cost = this.formData.cost / 1.0
      if (this.action == 'Add') {
        this.formData.userId = this.submitUserId
      }
      if (this.s3FilePath != null) {
        this.formData.s3FilePath = this.s3FilePath
        this.formData.s3FileContentType = this.s3FileContentType
      }
    },
    getChangedSubmissionData() {
      let changedData = {}
      let oldData = this.data
      changedData.cost = parseFloat(oldData.cost)
      changedData.billedAmount = parseFloat(oldData.billedAmount)
      changedData.changedCost = 0
      changedData.changedBilledAmount = 0
      for (var key in this.formData) {
        if (oldData[key] != this.formData[key]) {
          changedData[key] = this.formData[key]
        }
      }
      if (changedData.cost != oldData.cost) {
        changedData.changedCost =
          parseFloat(changedData.cost) - parseFloat(oldData.cost)
      }
      if (changedData.billedAmount != oldData.billedAmount) {
        changedData.changedBilledAmount =
          parseFloat(changedData.billedAmount) -
          parseFloat(oldData.billedAmount)
      }
      return changedData
    },
    editExpenseSubmission() {
      let self = this
      self.prepareFormDataForSubmit()
      self.$store
        .dispatch('editExpenseSubmission', {
          id: self.formData.id,
          changedData: self.getChangedSubmissionData(),
          projectId: self.formData.projectId,
          taskId: self.formData.taskId,
        })
        .then(result => {
          if (result.success != true) {
            self.$emit('error', result.data.error.message)
          } else {
            self.$emit('success', 'Successfully edited expense submission!')
            self.$emit('update-table', {
              action: 'edit',
              item: result.data.expensesubmission.Attributes,
            })
          }
        })
    },
    deleteExpenseSubmission() {
      let self = this
      self.$store
        .dispatch('deleteExpenseSubmission', {
          id: this.formData.id,
          changedData: {
            changedCost: -this.data.cost,
            changedBilledAmount: -this.data.billedAmount,
          },
          taskId: this.formData.taskId,
          projectId: this.formData.projectId,
        })
        .then(result => {
          if (result.success != true) {
            self.$emit('error', result.data.error.message)
          } else {
            self.$emit('success', 'Successfully deleted expense submission!')
            self.$emit('update-table', {
              action: 'delete',
              item: self.formData.id,
            })
          }
        })
    },
    addExpenseSubmission() {
      let self = this
      self.prepareFormDataForSubmit()
      self.$store.dispatch('submitExpense', self.formData).then(result => {
        if (result.success != true) {
          self.$emit('error', result.data.error.message)
        } else {
          self.$emit('success', 'Successfully added expense submission!')
          self.$emit('update-table', {
            action: 'add',
            item: result.data.expensesubmission,
          })
        }
      })
    },
    getPresignedUrl() {
      if (this.fileData != null) {
        this.s3FilePath =
          this.loggedInUser.companyId +
          '/' +
          this.formData.projectId +
          '/' +
          this.formData.taskId +
          '/expenses/' +
          moment().format('YYYY-MM-DD h-mm-ss a') +
          this.fileData.name
        this.s3FileContentType = this.fileData.type
        let payload = {
          action: 'putObject',
          path: this.s3FilePath,
          contentType: this.fileData.type,
        }
        let self = this
        self.$store.dispatch('getPresignedUrl', payload).then(result => {
          if (result.success == false) {
            self.$emit('error', result.data.error.message)
          } else {
            self.presignedUrl = result.data
            self.uploadFileToS3()
          }
        })
      } else {
        this.submitExpense()
      }
    },
    uploadFileToS3() {
      let contentType = this.fileData.type
      var reader = new FileReader()
      reader.readAsDataURL(this.fileData)
      let self = this
      reader.addEventListener('load', () => {
        let payload = {
          presignedUrl: self.presignedUrl,
          contentType: contentType,
          fileBody: reader.result,
        }

        self.$store.dispatch('uploadFileToS3', payload).then(result => {
          if (result.success == false) {
            self.$emit('error', result.data.error.message)
          } else {
            self.submitExpense()
          }
        })
      })
    },
    isNumber: function(evt) {
      evt = evt ? evt : window.event
      var charCode = evt.which ? evt.which : evt.keyCode
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    resetErrors() {
      this.errorMessage = null
      this.successMessage = null
      this.dialogSuccessMessage = null
      this.dialogErrorMessage = null
    },
  },
  beforeMount() {
    this.formData = JSON.parse(JSON.stringify(this.data))
    this.formData.userId = this.userid
    if (this.action == 'Edit') {
      this.markupPercent =
        (parseFloat(this.formData.billedAmount) /
          parseFloat(this.formData.cost) -
          1) *
        100
      this.cost = this.formData.cost
    }
    for (var serviceType of this.projectStoreData[this.formData.projectId]
      .serviceTypes) {
      if (serviceType.id == this.formData.serviceType) {
        this.taskRate = serviceType.laborRate
      }
    }
    if (this.action == 'Add') {
      if (this.taskRate > 0) {
        this.markupPercent = this.projectStoreData[
          this.formData.projectId
        ].defaultExpenseMarkup
      } else {
        this.markupPercent = 0
      }
      this.formData.reimburse = false
      this.formData.date = this.currentDate
      this.formData.billedAmount = 0
      this.formData.cost = 0
    }
  },
}
</script>
